import React from 'react';
// import { Carousel } from 'react-responsive-carousel';
import Carousel from '../carousel/carousel';






class Mantra1_6 extends React.Component {
    render() {
        return (
            <div>
                <div className="shared_bg">
                    <Carousel />
                    <div className="container">
                        <div className="shared_post">
                            <img src="/assets/img/thank.png" className="img-fluid d-block mx-auto" alt="" />
                            <h5>Your post has benn shared!</h5>
                        </div>
                        <div className="preview_btn">
                            <a href="#">Okay</a>
                        </div>
                        <div className="home_btn">
                            <a href="#">Go to Mantra's Home &#10230;</a>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default Mantra1_6;